<template>
  <v-container>
    <div class="mobile-header">
      <router-link class="mobile-header-logo" to="/">
        <Logo />
      </router-link>
      <div class="mobile-header-ham" @click="isNavbarOpen = !isNavbarOpen">
        <mobile-hamburger :is-open="isNavbarOpen" />
      </div>
      <div
        class="mobile-header-nav"
        :class="{ 'mobile-header-nav-active': isNavbarOpen }"
      >
        <div class="mobile-header-nav-links">
          <button @click="openMenu(1)" to="/" class="header-nav-item">
            <span>PRODUCTS</span>
            <IconCarrot />
          </button>
          <div v-if="activeLink === 1" class="header-nav-links">
            <router-link to="/">Product 1</router-link>
            <router-link to="/">Product 2</router-link>
            <router-link to="/">Product 3</router-link>
            <router-link to="/">Product 4</router-link>
            <router-link to="/">Product 5</router-link>
          </div>
          <button @click="openMenu(2)" to="/" class="header-nav-item">
            <span>SOLUTIONS</span>
            <IconCarrot />
          </button>
          <div v-if="activeLink === 2" class="header-nav-links">
            <router-link to="/">Solutions 1</router-link>
            <router-link to="/">Solutions 2</router-link>
            <router-link to="/">Solutions 3</router-link>
            <router-link to="/">Solutions 4</router-link>
            <router-link to="/">Solutions 5</router-link>
          </div>
          <router-link to="/pricing" class="header-nav-item"
            >PRICING</router-link
          >
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import Logo from "@/components/icons/Logo";
import MobileHamburger from "@/components/MobileHamburger";
import IconCarrot from "@/components/icons/IconCarrot";
export default {
  components: {
    Logo,
    MobileHamburger,
    IconCarrot,
  },
  data() {
    return {
      isNavbarOpen: false,
      activeLink: null,
    };
  },
  methods: {
    openNavbar() {},
    openMenu(row) {
      if (!this.activeLink) {
        this.activeLink = row;
      } else {
        this.activeLink = null;
      }
    },
  },
  watch: {
    $route() {
      this.isNavbarOpen = false;
    },
  },
};
</script>

<style lang="scss">
.mobile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 0;

  &-logo {
    z-index: 99;
  }

  &-nav {
    background: #f2eee8;
    position: fixed;
    top: 0;
    right: 0;
    height: 100%;
    width: 100%;
    z-index: 9;
    transform: translateX(100%);
    transition: all 0.2s;
    padding: 80px 30px;

    &-links {
      margin-top: 80px;

      button {
        outline: none;
      }

      .header-nav-links {
        position: static;
      }

      .header-nav-item {
        display: flex;
        margin-right: 0;
        width: 100%;
        padding: 14px 0;

        &:not(:last-child) {
          border-bottom: 1px solid #00000017;
        }
        span {
          margin-right: auto;
        }
      }

      .header-nav-links {
        width: 100%;
        background: transparent;
        box-shadow: none;
        a {
          padding: 5px 0;
        }
      }
    }

    &-active {
      transform: translateX(0);
    }
  }
}
</style>
